'use client';

import { Popover } from '@headlessui/react';
import Icon from '@mdi/react';
import { forwardRef } from 'react';

import styles from './IconButton.module.sass';

interface IconButtonProps {
    className?: string;
    disabled?: boolean;
    icon: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    title?: string;
    isPopoverButton?: boolean;
    isExtraContrast?: boolean;
}

const IconButton = (
    {
        className = '',
        disabled,
        icon,
        onClick,
        title,
        isPopoverButton = false,
        isExtraContrast = false,
        ...props
    }: IconButtonProps,
    ref: React.ForwardedRef<HTMLButtonElement>,
) => {
    const iconClassNames = `${styles.iconbutton} ${
        isExtraContrast ? 'bg-black/10' : 'bg-white/10'
    }`;

    if (isPopoverButton) {
        return (
            <Popover.Button
                ref={ref}
                className={`${iconClassNames} ${className}`}
                onClick={onClick}
                disabled={disabled}
                title={title}
                {...props}
            >
                <Icon path={icon} size={1} />
            </Popover.Button>
        );
    }

    return (
        <button
            ref={ref}
            className={`${iconClassNames} ${className}}`}
            onClick={onClick}
            disabled={disabled}
            title={title}
            {...props}
        >
            <Icon path={icon} size={1} />
        </button>
    );
};

export default forwardRef<HTMLButtonElement, IconButtonProps>(IconButton);
